// src/components/AddNewReasonModal.js
import React, { useState } from "react";
import axios from "axios";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, } from "@mui/material";
import { useAuth } from '../context/AuthContext';

const AddNewReasonModal = ({ open, onClose, onSubmit, loggedInUser, companyData, connectionString }) => {
    const { user, selectedCompany, loading } = useAuth();
    const [newReason, setNewReason] = useState("");
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const role = loggedInUser?.UserCategory;
    const path = connectionString;

    const handleSubmit = async () => {
        if (!newReason.trim()) {
            alert("Please enter a reason.");
            return;
        }
        try {
            const payload = {
                Reason: newReason,
                userId,
                companyId
                // Include additional fields as required by your backend.
            };
            const res = await axios.post(`${path}/api/reason`, payload);
            if (res.status === 201 && res.data.success) {
                alert("New reason added successfully!");
                onSubmit(res.data.data); // Assume the API returns the new record in res.data.data
                onClose();
            } else {
                alert("Failed to add reason.");
            }
        } catch (error) {
            console.error("Error adding new reason:", error);
            alert("Server error");
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Add New Reason</DialogTitle>
            <DialogContent>
                <TextField label="Reason" value={newReason} onChange={(e) => setNewReason(e.target.value)} placeholder="Enter new reason" fullWidth margin="normal" />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleSubmit} color="primary" sx={{ borderRadius: 1, px: 3, py: 1 }} >
                    Submit
                </Button>
                <Button variant="outlined" onClick={onClose} color="error" sx={{ borderRadius: 1, px: 3, py: 1 }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddNewReasonModal;